import Plus from '../../../components/svg/plus'
import { Desktop } from '../../../components/media'
import { SortOptionsArray } from '../../../api-client/enums/vehicle-sort-options'

export default function SortHandle({ name, onClick, children, query, onDismiss }) {
  const mapSort = (param) => {
    if (
      SortOptionsArray.find(
        (x) => x.value.fieldName === param?.fieldName && x.value.sortOrder === param?.sortOrder,
      )
    ) {
      return SortOptionsArray.find(
        (x) => x.value.fieldName === param.fieldName && x.value.sortOrder === param.sortOrder,
      )['label']
    }
  }
  return (
    <button className='flatBtn filterBtn' onClick={() => onClick(name)}>
      {mapSort(query.sortType) !== 'Best Match' && mapSort(query.sortType) !== undefined && (
        <span className='dismiss' onClick={onDismiss}>
          &#9587;
        </span>
      )}
      {mapSort(query.sortType) || 'Best Match'}
      {children}
      <Desktop>
        <Plus width='12' height='12' fill='var(--primary-color)' />
      </Desktop>
      <style jsx>{`
        .dismiss {
          z-index: 100;
          margin-right: 10px;
        }
        .filterBtn {
          position: relative;
          display: inline-block;
          width: 25rem;
          height: 4.2rem;
          padding: 0 2.5rem 0 1.9rem;
          border-radius: 2.1rem;
          border: 0.2rem solid #e9ecf2;
          text-align: left;
          color: var(--secondary-text-color);
          font-size: 1.6rem;
          font-weight: 700;
          background-color: white;
          white-space: nowrap;

          &:hover,
          &:active {
            border-color: var(--primary-color);
            color: var(--primary-color);
          }

          :global(svg) {
            position: absolute;
            top: 50%;
            right: 1.25rem;
            transform: translateY(-50%);
          }
        }

        @media (max-width: 1510px) {
          .filterBtn {
            font-size: 1.4rem;
          }
        }

        @media (max-width: 1385px) {
          .filterBtn {
            font-size: 1.3rem;
          }
        }

        @media (max-width: 1024px) {
          .filterBtn {
            height: 3.5rem;
            padding: 0;
            text-align: center;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </button>
  )
}
